<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent width="80%">
      <v-btn class="hidden-sm-and-down" slot="activator" color="primary" dark alt="Incluir Itinerário Formativo" @click="abrirCadastro()" title="Incluir tinerário Formativo"><v-icon>add</v-icon>Incluir</v-btn>
      <v-card>
        <v-card-title>
          <span class="headline">{{formTitle}}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="form">
            <v-layout wrap>
              <v-flex xs12 sm6 md9>
                <v-text-field v-model="nomeCurso" disabled
                  label="Nome do Curso"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field v-model="itinerarioFormativo.nome" :error-messages="fieldErrors('itinerarioFormativo.nome')"
                  label="Nome"  @blur="$v.itinerarioFormativo.nome.$touch()"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field v-model="itinerarioFormativo.sigla" :error-messages="fieldErrors('itinerarioFormativo.sigla')"
                  label="Sigla"  @blur="$v.itinerarioFormativo.sigla.$touch()"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <date-picker-custom id="dataInicioVigencia" label="Data Inicio Vigência" :v-model="itinerarioFormativo.dataInicioVigencia" @date="itinerarioFormativo.dataInicioVigencia = $event" 
                :error-messages="fieldErrors('itinerarioFormativo.dataInicioVigencia')"></date-picker-custom>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <date-picker-custom id="dataFinalVigencia" label="Data Final Vigência" :v-model="itinerarioFormativo.dataFinalVigencia" @date="itinerarioFormativo.dataFinalVigencia = $event" 
                :error-messages="fieldErrors('itinerarioFormativo.dataFinalVigencia')"></date-picker-custom>
              </v-flex>
               <v-flex xs12 sm6 md2>
                <v-checkbox type="checkbox" label="Ativo" v-model="itinerarioFormativo.ativo" disabled></v-checkbox>
              </v-flex>
            </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click.native="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" type="submit" @click.native="salvar" dark>{{btnTitle}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import itinerarioFormativoService from "@/service/itinerario/ItinerarioFormativoService";
import ItinerarioFormativo from "@/model/itinerario/ItinerarioFormativo";
import DatePickerCustom from "@/components/Custom/DatePickerCustom";
import {
  required,
  maxLength,
  numeric,
  decimal
} from "vuelidate/lib/validators";
import { dataFimMenor } from "@/utils/validators";
import validationMixin from "@/mixins/validationMixin";
import messageMixin from "@/mixins/message";
import EventBus from "@/utils/EventBus";
export default {
  name: "ModalCadastroItinerarioFormativo",
  components: {
    DatePickerCustom
  },
  props: {
    idCurso: Number,
    nomeCurso: String
  },
  mixins: [validationMixin, messageMixin],
  validations: {
    itinerarioFormativo: ItinerarioFormativo.validations(
      required,
      maxLength,
      numeric,
      decimal,
      dataFimMenor
    )
  },
  validationMessages: {
    itinerarioFormativo: ItinerarioFormativo.validationMessages()
  },
  data() {
    return {
      componentes: [],
      loading: false,
      btnTitle: "",
      dialog: false,
      formTitle: "",
      itinerarioFormativo: new ItinerarioFormativo()
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  async created() {
    EventBus.$on("editaItinerarioFormativo", async idIterativoFormativo => {
      this.formTitle = "Alterar Itinerário Formativo";
      this.btnTitle = "Alterar";
      this.itinerarioFormativo = await itinerarioFormativoService.editar(idIterativoFormativo);
      this.verificarSelecaoAtivo();
      this.dialog = true;
    });
    EventBus.$on("updateDatePickerCustom", async (id, date) => {
        if(id === "dataFinalVigencia") {
          this.itinerarioFormativo.dataFinalVigencia = date;
        }
    });
    
  },
  methods: {
    abrirCadastro() {
      this.formTitle = "Cadastrar Itinerário Formativo";
      this.btnTitle = "Salvar";
      this.dialog = true;
      this.itinerarioFormativo.idCurso = this.idCurso;
    },
    salvar() {
      this.verificarSelecaoAtivo();
      this.$v.itinerarioFormativo.$touch();
      if (this.$v.$invalid) {
        return;
      }
      itinerarioFormativoService.salvar(this.itinerarioFormativo).then(() => {
        this.$emit("itinerarioFormativoCadastrado", true);
        this.dialog = false;
      });
    },
    verificarSelecaoAtivo() {
      if(this.itinerarioFormativo.dataFinalVigencia) {
        this.itinerarioFormativo.ativo = false;
      } else {
        this.itinerarioFormativo.ativo = true;
      }
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.$v.$reset();
        this.itinerarioFormativo = new ItinerarioFormativo();
        EventBus.$emit("resetCustom");
      }, 300);
    }
  }
};
</script>
